import React from 'react';
import { MDBProgress } from 'mdbreact';

export default ({ className = '' }) => (
  <div className={className}>
    <MDBProgress material preloader />
  </div>
);
